<template>
  <span class="wxid" :class="{ 'wxid--dark': dark }">
    <span class="wxid__id">{{ WECHAT_ID }}</span>
    <button type="button" class="wxid__btn" @click="copy">{{ done ? '✓' : c.wechatId.copy }}</button>
  </span>
</template>

<script setup>
import { ref } from 'vue'
import { content as c, WECHAT_ID } from '@/i18n'
import { toast } from '@/toast'
import { track } from '@/track'

// 手机上打开网页没法扫自己屏幕上的二维码，提供微信号一键复制
defineProps({ dark: Boolean })
const done = ref(false)

// 先用同步的 execCommand（各家手机浏览器、微信内置浏览器兼容性最好），失败再用 Clipboard API（最多等 1.5 秒）
function legacyCopy() {
  try {
    const t = document.createElement('textarea')
    t.value = WECHAT_ID
    t.setAttribute('readonly', '')
    t.style.position = 'fixed'; t.style.top = '0'; t.style.opacity = '0'
    document.body.appendChild(t)
    t.focus(); t.select(); t.setSelectionRange(0, WECHAT_ID.length)
    const ok = document.execCommand('copy')
    document.body.removeChild(t)
    return ok
  } catch (e) { return false }
}

async function copy() {
  let ok = legacyCopy()
  if (!ok && navigator.clipboard) {
    try {
      ok = await Promise.race([
        navigator.clipboard.writeText(WECHAT_ID).then(() => true),
        new Promise(resolve => setTimeout(() => resolve(false), 1500)),
      ])
    } catch (e) { ok = false }
  }
  if (ok) {
    done.value = true
    setTimeout(() => { done.value = false }, 2500)
    toast(c.value.wechatId.copied, 'success')
    track('copy_wechat_id')
  } else {
    toast(c.value.wechatId.failed + WECHAT_ID, 'error', 8000)
  }
}
</script>

<style scoped>
.wxid { display: inline-flex; align-items: center; gap: 10px; }
.wxid__id { font-family: var(--font-mono); font-size: 15px; color: var(--paper-text); user-select: all; }
.wxid__btn {
  font-family: var(--font-mono); font-size: 11px; letter-spacing: .12em; text-transform: uppercase;
  padding: 4px 10px; border: 1px solid var(--paper-line); color: var(--paper-muted); min-width: 52px;
}
.wxid__btn:hover { border-color: var(--accent); color: var(--accent); }
.wxid--dark .wxid__id { color: var(--ink-text); }
.wxid--dark .wxid__btn { border-color: var(--ink-line); color: var(--ink-muted); }
</style>
